import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\CitationController::store
* @see Http/Controllers/CitationController.php:24
* @route '/projects/{project}/articles/{paper}/cite'
*/
export const store = (args: { project: string | number | { id: string | number }, paper: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paper: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects/{project}/articles/{paper}/cite',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CitationController::store
* @see Http/Controllers/CitationController.php:24
* @route '/projects/{project}/articles/{paper}/cite'
*/
store.url = (args: { project: string | number | { id: string | number }, paper: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paper: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            paper: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        paper: typeof args.paper === 'object'
        ? args.paper.id
        : args.paper,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{paper}', parsedArgs.paper.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CitationController::store
* @see Http/Controllers/CitationController.php:24
* @route '/projects/{project}/articles/{paper}/cite'
*/
store.post = (args: { project: string | number | { id: string | number }, paper: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paper: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CitationController::store
* @see Http/Controllers/CitationController.php:24
* @route '/projects/{project}/articles/{paper}/cite'
*/
const storeForm = (args: { project: string | number | { id: string | number }, paper: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paper: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CitationController::store
* @see Http/Controllers/CitationController.php:24
* @route '/projects/{project}/articles/{paper}/cite'
*/
storeForm.post = (args: { project: string | number | { id: string | number }, paper: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paper: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\CitationController::updateStyle
* @see Http/Controllers/CitationController.php:79
* @route '/projects/{project}/citation-style'
*/
export const updateStyle = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStyle.url(args, options),
    method: 'patch',
})

updateStyle.definition = {
    methods: ["patch"],
    url: '/projects/{project}/citation-style',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\CitationController::updateStyle
* @see Http/Controllers/CitationController.php:79
* @route '/projects/{project}/citation-style'
*/
updateStyle.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return updateStyle.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CitationController::updateStyle
* @see Http/Controllers/CitationController.php:79
* @route '/projects/{project}/citation-style'
*/
updateStyle.patch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStyle.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\CitationController::updateStyle
* @see Http/Controllers/CitationController.php:79
* @route '/projects/{project}/citation-style'
*/
const updateStyleForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStyle.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CitationController::updateStyle
* @see Http/Controllers/CitationController.php:79
* @route '/projects/{project}/citation-style'
*/
updateStyleForm.patch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStyle.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateStyle.form = updateStyleForm

const CitationController = { store, updateStyle }

export default CitationController